<template>
  <!-- <el-drawer
    size="1100px"
    :title="model.title"
    :visible="visible"
    :before-close="closeDialog"
    class="video-drawer"
    :append-to-body="true"
  > -->
  <custom-draw width="1100px" class="video-drawer" :wrapperClosable="false" :title="model.title" :visible="visible" v-on="$listeners">
    <div class="info-content">
      <el-form :model="form" ref="form" class="form-section" label-position="top">
        <div class="info-content-box">
          <div class="info-content-left">
            <!-- :label="$t('教程封面', 'label_tutorial_cover')" -->
            <el-form-item prop="tutorialImage" :rules="rules.tutorialImage">
              <t-upload
                :limit="1"
                type="videoCover"
                :title="$t('training_tutorial_videoNode_drawer.shi_pin_feng_mian')"
                :bizId="form.trainingId"
                bizType="tms.icon"
                ref="tmsIcon"
                :autoUpload="false"
                v-model="imgList"
                @effect="changeUploadRules"
                @change="changeUploadRules"
              ></t-upload>
            </el-form-item>
            <el-form-item :label="$t('training_tutorial_videoNode_drawer.shi_pin_ming_cheng')" prop="trainingName" :rules="rules.trainingName">
              <el-input v-model="form.trainingName" :placeholder="$t('training_tutorial_videoNode_drawer.qsrspmc')"></el-input>
            </el-form-item>
            <el-form-item :label="$t('training_tutorial_videoNode_drawer.shun_xu')" prop="showOrder" :rules="rules.showOrder">
              <el-input type="number" :min="0" v-model.number="form.showOrder" :placeholder="$t('training_tutorial_videoNode_drawer.qing_shu_ru_shun_xu')" style="width: 100%"></el-input>
            </el-form-item>
            <el-form-item prop="trainingDesc" :rules="rules.trainingDesc" :label="$t('training_tutorial_videoNode_drawer.miao_shu')">
              <el-input type="textarea" v-model="form.trainingDesc" :placeholder="$t('training_tutorial_videoNode_drawer.qing_shu_ru_miao_shu')"></el-input>
            </el-form-item>
            <el-form-item prop="productCode" :label="$t('training_tutorial_videoNode_drawer.chan_pin_xing_hao')">
              <el-input type="text" v-model="form.productCode" :placeholder="$t('training_tutorial_videoNode_drawer.qsrcpxh')" disabled="disabled"></el-input>
            </el-form-item>
            <el-form-item prop="langCode" :label="$t('training_tutorial_videoNode_drawer.yu_zhong')">
              <custom-select code="language_type" v-model="form.langCode" :placeholder="$t('Common.com_please_select')" disabled="disabled" width="100%"></custom-select>
            </el-form-item>
          </div>
          <div class="node-content">
            <el-form-item prop="tutorialVideo" :rules="rules.tutorialVideo" style="margin-bottom: 16px">
              <!-- :label="$t('视频', 'label_training_video')" -->
              <!-- {{videoList}} -->
              <t-upload
                :limit="1"
                type="videoProgress"
                bizType="tms.video"
                ref="tutorialVideo"
                :autoUpload="false"
                :title="$t('training_tutorial_videoNode_drawer.shang_chuan_shi_pin')"
                :bizId="form.trainingId"
                v-model="videoList"
                :tip="$t('training_tutorial_videoNode_drawer.wjbncg500M')"
                accept=".mp4, .qlv, .qsv, .ogg, .flv, .avi, .wmv, .rmvb"
                @effect="changeUploadRules"
                @change="changeUploadRules"
              ></t-upload>
            </el-form-item>
            <div class="role-list">
              <ul>
                <li>
                  <div class="item-head ub">
                    <el-row :gutter="10" class="ub-f1">
                      <el-col :span="7">
                        <h1>
                          {{ $t('training_tutorial_videoNode_drawer.zhang_jie_ming_cheng') }}
                        </h1>
                      </el-col>
                      <el-col :span="13">
                        <h1>
                          {{ $t('training_tutorial_videoNode_drawer.miao_shu') }}
                        </h1>
                      </el-col>
                      <el-col :span="4">
                        <h1>
                          {{ $t('training_tutorial_videoNode_drawer.zjkssj') }}
                        </h1>
                      </el-col>
                    </el-row>
                    <div class="icon-box"></div>
                  </div>
                  <div class="children">
                    <div class="item ub" v-for="(item, index) in nodeList" :key="index">
                      <!--  -->
                      <el-row :gutter="10" class="ub-f1">
                        <!-- 章节名称 -->
                        <el-col :span="7">
                          <el-input :placeholder="$t('training_tutorial_videoNode_drawer.qsrzjmc')" v-model="item.nodeName" maxlength="50" style="width: 100%">
                            <template slot="prepend">{{ index + 1 }}</template>
                          </el-input>
                        </el-col>
                        <!-- 描述 -->
                        <el-col :span="13">
                          <el-input :placeholder="$t('training_tutorial_videoNode_drawer.qing_shu_ru_miao_shu')" v-model="item.nodeDesc" maxlength="200" style="width: 100%"></el-input>
                        </el-col>
                        <!-- 章节开始时间 -->
                        <el-col :span="4">
                          <el-input-number
                            :placeholder="$t('training_tutorial_videoNode_drawer.jdkssjm')"
                            :min="0"
                            v-model="item.startTime"
                            controls-position="right"
                            style="width: 100%; margin-right: 3%"
                            :label="$t('training_tutorial_videoNode_drawer.jdkssjm')"
                          ></el-input-number>
                        </el-col>
                      </el-row>
                      <div class="icon-box" @click="deleteNodeItem(index, item)">
                        <!-- v-if="index !== 0 ||  model.type==='edit'"  -->
                        <i class="icon icon-shanchu"></i>
                      </div>
                    </div>
                  </div>
                </li>
              </ul>
              <div class="role-add-btn" @click="addNodeItem">
                <div style="display: inline-block">
                  <i class="icon icon-add"></i>
                  <span>{{ $t('training_tutorial_videoNode_drawer.tian_jia_zhang_jie') }}</span>
                </div>
              </div>
            </div>
            <!-- <div class="role-add-btn" @click="addNodeItem">
              <div style="display: inline-block">
                <i class="icon icon-add"></i>
                <span>{{$t('page_content_add_node')}}</span>
              </div>
            </div> -->
          </div>
        </div>
      </el-form>
      <div class="drawer__footer">
        <el-button type="primary" @click="saveTutorial">
          {{ $t('Common.com_save') }}
        </el-button>
        <el-button @click="closeDialog">
          {{ $t('Common.com_cancel') }}
        </el-button>
      </div>
    </div>
  </custom-draw>
  <!-- </el-drawer> -->
</template>

<script>
/** 查看产品详情 */

import apis from '@/utils/apis';
import tUpload from '@/components/upload.vue';

export default {
  components: {
    tUpload,
  },
  props: {
    productId: [Number, String],
    productCode: [String],
    langCode: [String],
    trainingId: [String],
    model: {
      type: Object,
      default() {
        return {
          type: '', // add、edit
          title: '',
        };
      },
    },
  },
  data() {
    return {
      bizType: 'videoNode',
      form: {
        langCode: '', // 默认语言代码
        productCode: '', // 产品编码
        trainingDesc: '', // 教程描述
        trainingName: '', // 教程名称
        trainingState: '', // 状态，1-启用，0-停用
        trainingIcon: '', // 教程主图
        trainingVedio: '', // 教程视频
        attachList: [], // 资源
        vedioDuration: '', // 视频时长（秒）
        trainingId: '',
        showOrder: 0, // 顺序
        // 用于验证
        tutorialImage: '',
        tutorialVideo: '',
        nodes: [], // 章节
      },
      imgList: [],
      imgIndex: 0,
      videoList: [],
      nodeList: [
        {
          endTime: 0,
          startTime: 0,
          nodeDesc: '',
          nodeName: '',
          // nodeState: false,
          // nodeId: 0,
        },
      ],
      formItem: {
        endTime: 0,
        startTime: 0,
        nodeDesc: '',
        nodeName: '',
        // nodeState: false,
        // nodeId: 0,
      },
      tabIndex: 0,
      visible: false,
    };
  },

  mounted() {
    this.init();

    setTimeout(() => {
      const tips = {
        tutorialImage: this.$t('training_tutorial_videoNode_drawer.qscfm'),
        trainingName: this.$t('training_tutorial_videoNode_drawer.btxcdzc50gzf'),
        showOrder: this.$t('training_tutorial_videoNode_drawer.xspxbnxy0'),
        trainingDesc: this.$t('training_tutorial_videoNode_drawer.cdzc200gzf'),
        tutorialVideo: this.$t('training_tutorial_videoNode_drawer.qscjcsp'),
      };
      Object.keys(tips).forEach((key) => {
        this.rules[key].message = tips[key];
      });
    }, 100);
  },

  computed: {
    rules() {
      return {
        tutorialImage: {
          type: 'string',
          required: true,
          message: this.$t('Common.com_required')
        },
        trainingName: {
          type: 'string',
          required: true,
          message: this.$t('Common.com_required')
        },
        // 顺序
        showOrder: [{ type: 'number', min: 0, message: this.$t('Common.com_rules_number_min', [0]) }],
        trainingDesc: { type: 'string', max: 200, message: this.$t('Common.com_rules_length_max', [200]) },
        tutorialVideo: {
          type: 'string',
          required: true,
          message: this.$t('Common.com_required')
        },
      };
    },
  },
  methods: {
    init() {
      this.$nextTick(() => {
        this.visible = true;
      });
      this.form.langCode = this.langCode;
      this.form.productCode = this.productCode;
      if (this.model.type === 'edit') {
        this.form.trainingId = this.trainingId;
        this.getProductDetail();
      }
    },
    // 验证上传和获取视频时间
    changeUploadRules: function ({ duration = 0 } = {}) {
      // 验证
      this.form.tutorialImage = this.imgList.length > 0 ? 'tutorialImage' : '';
      this.form.tutorialVideo = this.videoList.length > 0 ? 'tutorialVideo' : '';
      if (duration) {
        this.form.vedioDuration = duration || 0;
      }
    },
    getProductDetail() {
      this.$getJSON(apis.tmsProductTrainingInfo, {
        trainingId: this.trainingId,
      }).then((res) => {
        this.form = res.data;
        this.nodeList = res.data.nodes || [];
        // 验证
        this.form.tutorialImage = this.imgList.length > 0 ? 'tutorialImage' : '';
        this.form.tutorialVideo = this.videoList.length > 0 ? 'tutorialVideo' : '';
      });
    },
    // 新增章节
    addNodeItem: function () {
      const videoItem = this.$refs.tutorialVideo.$refs.video;
      if (!videoItem) {
        const tips = this.$t('training_tutorial_videoNode_drawer.qscjcsp');
        this.$message.error(tips);
        return;
      }
      // 章节时间是否存在
      const hasStartTime = this.nodeList.find((i) => i.startTime === parseInt(videoItem.currentTime, 10));
      // 上传了视频
      if (videoItem && !hasStartTime) {
        this.formItem.startTime = parseInt(videoItem.currentTime, 10);
        this.nodeList.push(JSON.parse(JSON.stringify(this.formItem)));
        this.nodeSort();
      } else if (hasStartTime) {
        const tips = this.$t('training_tutorial_videoNode_drawer.jdsjycz');
        this.$message.error(tips);
      }
    },
    nodeSort: function () {
      this.nodeList.sort((a, b) => a.startTime - b.startTime);
    },
    // 删除规则项
    deleteNodeItem: function (index, { nodeId = '', nodeName = '' } = {}) {
      if (nodeId) {
        const tips = this.$t('training_tutorial_videoNode_drawer.qdyscsxjdom', [nodeName]);
        this.$showConfirm(tips)
          .then(() => {
            this.$postJSON(`${apis.tmsProductTrainingNodeDelete}/${nodeId}`).then(() => {
              this.nodeList.splice(index, 1);
            });
          })
          .catch(() => {});
      } else {
        this.nodeList.splice(index, 1);
      }
    },

    async saveTutorial() {
      // const arr = [];
      // await this.$refs.tmsIcon.submit();
      // await this.$refs.tutorialVideo.submit();

      // arr.push(this.$refs.tmsIcon.submit(), this.$refs.tutorialVideo.submit());
      // Promise.all(arr).then(() => {
      // 判断开始时间为负数
      this.$refs.form.validate(async (val) => {
        if (val) {
          const hasEmpty = this.nodeList.find((i) => i.nodeName === '' || i.startTime === '');
          if (this.nodeList.length > 0 && hasEmpty) {
            const tips = this.$t('training_tutorial_videoNode_drawer.qjzjtxwz');
            this.$message.error(tips);
            return;
          }
          // 判断开始时间为负数
          const hasNegative = this.nodeList.find((item) => item.startTime < 0);
          if (hasNegative) {
            const tips = this.$t('training_tutorial_videoNode_drawer.jdkssjbnwfs');
            this.$message.error(tips);
            return;
          }
          // 重复章节
          const nodeArr = [];
          const hasRepeat = this.nodeList.find((item) => {
            let res;
            if (nodeArr.length > 0) {
              res = nodeArr.find((pitem) => item.startTime === pitem.startTime);
            }
            nodeArr.push(item);
            return res;
          });
          if (hasRepeat) {
            const tips = this.$t('training_tutorial_videoNode_drawer.jdkssjbncf');
            this.$message.error(tips);
            return;
          }
          // 章节开始时间不能大于视频时长
          const hasOverTime = this.nodeList.find((item) => item.startTime > this.form.vedioDuration);
          if (hasOverTime) {
            const tips = this.$t('training_tutorial_videoNode_drawer.jdkssjbndyspsc');
            this.$message.error(tips);
            return;
          }

          await Promise.all([this.$refs.tmsIcon.submit(), this.$refs.tutorialVideo.submit()]);
          // 手动上传视频 特殊处理
          // this.videoList = this.videoList.map((i) => {
          //   const data = i.response ? i.response.data : {};
          //   const obj = {
          //     ...data,
          //     percentage: i.percentage,
          //     status: i.status
          //   };
          //   return obj;
          // });
          // 图片转换
          this.form.trainingIcon = this.imgList[0] ? this.imgList[0].attachPath : '';
          this.form.trainingVedio = this.videoList[0] ? this.videoList[0].attachPath : '';
          this.form.attachList = this.imgList.concat(this.videoList);
          // 章节保存
          this.nodeList.forEach((item, index) => {
            // item.modifier = null;
            item.endTime = (this.nodeList[index + 1] && this.nodeList[index + 1].startTime) || this.form.vedioDuration;
          });
          this.form.nodes = this.nodeList;

          if (this.form.trainingId) {
            this.$postJSON(apis.tmsProductTrainingUpdate, this.form).then(() => {
              this.$emit('success');
              this.closeDialog();
            });
          } else {
            this.$postJSON(apis.tmsProductTrainingAdd, this.form).then(() => {
              this.$emit('success');
              this.closeDialog();
            });
          }
        }
      });
      // });
    },
    // 关闭弹窗
    closeDialog: function () {
      this.visible = false;
      setTimeout(() => {
        this.$emit('close', false);
      }, 200);
    },
  },
};
</script>

<style lang="scss">
.video-drawer {
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
  position: fixed !important;
  span[role='heading']:focus {
    outline: none;
  }

  .el-drawer__body {
    padding: 0px;
    height: calc(100% - 51px);
  }

  .el-drawer__header {
    padding: 0;
    padding-left: 18px;
    line-height: 50px;
    font-size: 14px;
    font-weight: bold;
    color: #495057;
    border-bottom: 1px solid #e9ebec;
    margin-bottom: 0;
    padding-right: 20px;

    .el-icon-close {
      font-size: 14px;
      font-weight: bold;
    }
  }

  .el-drawer__body {
    position: relative;
    display: flex;
  }

  .info-content {
    display: flex;
    // height: calc( 100% - 50px);
    flex-direction: column;
    .form-section {
      display: flex;
      flex: 1;
      overflow-y: auto;
      .info-content-box {
        display: flex;
        .info-content-left {
          width: 296px;
          padding-right: 24px;
          padding: 24px;
          background: rgba(248, 249, 251, 1);
          .cur-img {
            $r: 200px;
            width: $r;
            height: $r;
            margin: 24px auto 0 auto;
            position: relative;
          }

          .img-group {
            margin-top: 5px;
            margin-bottom: 20px;
            display: flex;
            justify-content: center;

            .img-item {
              $r: 46px;
              width: $r;
              height: $r;
              position: relative;
              &:hover {
                cursor: pointer;
              }

              &.cur {
                border: 1px solid #f2f3fb;
                border-radius: 2px;
              }

              &:nth-child(n + 2) {
                margin-left: 5px;
              }
            }
          }

          .img {
            position: absolute;
            left: 0;
            right: 0;
            top: 0;
            bottom: 0;
            margin: auto;
            max-width: 100%;
            max-height: 100%;
          }

          .param-list {
            .param-item {
              overflow: hidden;
              line-height: 27px;
              font-size: 12px;
              color: #98a6ad;

              .param-key {
                float: left;
              }
              .param-val {
                float: right;
              }
            }
          }
        }

        .node-content {
          flex: 1;
          display: flex;
          flex-direction: column;
          // padding-left: 24px;
          padding: 24px;
          overflow: hidden;
          .inner-content {
            height: calc(100% - 40px);
            // overflow-y: auto;
          }

          .role-list {
            // padding-top: 16px;
            flex: 1;
            overflow-y: auto;
            ul li {
              margin-top: 10px;
              // border: 1px solid rgba(228, 228, 228, 1);
              &:first-child {
                margin-top: 0;
              }
            }
            .item-head {
              // background: rgba(245, 245, 245, 1);
              border-bottom: 1px solid rgba(228, 228, 228, 1);
              padding: 0 10px;
              h1 {
                line-height: 32px;
                font-size: 12px;
                color: #262626;
                font-weight: bold;
                text-indent: 6px;
              }
              .icon-box {
                width: 30px;
                margin-left: 10px;
              }
            }
            .children {
              padding: 16px 0;
              .item {
                padding: 16px 10px 0;
                &:first-child {
                  padding-top: 0;
                }
                .icon-box {
                  line-height: 30px;
                  width: 30px;
                  margin-left: 10px;
                  text-align: center;
                  .icon {
                    color: #00afff;
                    font-size: 14px;
                    cursor: pointer;
                  }
                }
              }
              .el-input-group__append {
                border-radius: 0;
                .copy-up {
                  padding: 0 8px;
                  .el-radio__label {
                    padding-left: 5px;
                  }
                }
              }
            }
          }
          .role-add-btn {
            background: rgba(245, 245, 245, 1);
            border: 1px dashed rgba(228, 228, 228, 1);
            line-height: 30px;
            text-align: center;
            color: #333333;
            font-size: 12px;
            // margin-top: 10px;
            cursor: pointer;
            .icon {
              color: #00afff;
              font-size: 10px;
              margin-right: 8px;
              float: left;
            }
          }
        }
      }
    }
  }

  .tab {
    ul li {
      border-top: 1px solid #eef2f8;
      line-height: 40px;
      &:nth-child(1) {
        border-left: 1px solid #eef2f8;
      }
      &.current {
        border-top: 2px solid #0d9ae0;
        line-height: 39px;
      }
    }
    .ub-f1 {
      border-top: none;
    }
  }

  .el-input-group__prepend {
    background-color: #fff;
    background: rgba(248, 249, 251, 1);
    border-radius: 2px 0px 0px 2px;
    color: rgba(73, 80, 88, 1);
    padding: 0;
    width: 30px;
    text-align: center;
  }
  .avatar-uploader {
    font-size: 0;
    line-height: 1;
  }
  .el-upload-list__item:first-child {
    margin-top: 0;
  }
  .drawer__footer {
    padding: 16px 24px;
    border-top: 1px solid #e9ebec;
    box-sizing: border-box;
  }
}
</style>
